import {
  Component,
  computed,
  HostBinding,
} from '@angular/core';
import { IconsComponent } from '@shared/components/icons/icon.component';
import {
  bootstrapArrow90degLeft,
} from '@ng-icons/bootstrap-icons';
import {
  CustomButtonComponent,
} from '@shared/components';
import {
  buttonConfig,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'undo-claim-creation-process-button-component',
  templateUrl: 'undo-claim-creation-process-button.component.html',
  imports: [CustomButtonComponent, TranslateModule],
})
export class UndoClaimCreationProccessButtonComponent {
  @HostBinding('style.display') display = 'none';

  protected blockClaimCreationProgressModalDismiss = true;

  protected configs = computed(
    () =>
      ({
        type: 'button',
        label: {
          key: 'app.pageId.undo-claim-creation-process',
        },
        startContent: {
          content: IconsComponent,
          data: {
            icon: bootstrapArrow90degLeft,
            size: '15'
          },
        },
        color: 'tertiary',
        animation: 'slide-in-right',
        action: () => {
          console.log('undo process')
          window.self!.close();
        },
      } as buttonConfig)
  );
}
